import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { GetById, GetLatestBlogs } from '../../service/BlogService'; // You need to create this if not existing

export default function ViewBlog() {
  const {
    setIsLoading,
    setAppError,
    setAppErrorMessage,
    setAppErrorTitle,
    setAppErrorMode,
  } = useGlobalContext();

  const { id } = useParams(); // Get blog id from route params
  const [blog, setBlog] = useState(null);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [image, setImage] = useState(null);
  const [blogCategoryId, setBlogCategoryId] = useState('');

  const fetchBlogById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setBlog(response.blog);
        setName(response.blog.name);
        setImage(response.blog.image);
        setDescription(response.blog.description);
        setBlogCategoryId(response.blog.blogCategory.id);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

useEffect(() => {
  if (id) {
    fetchBlogById();
  }
}, [id]); // 👈 depend on 'id'


   //latest blogs
    const [latestBlogs, setBlogs] = useState([]);
    const fetchLatestBlogs = async () => {
      try {
        setIsLoading(true);
        const response = await GetLatestBlogs(5); // Load latest 4 blogs
        setBlogs(response.blogs || []);
      } catch (error) {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage("Failed to load latest blogs");
        setAppErrorMode("error");
      } finally {
        setIsLoading(false);
      }
    };
    useEffect(() => {
      fetchLatestBlogs();
    }, []);
  

  return (
    <>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>View Blog</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/blog/list/grid"> All Blogs </Link>  / View Blog
            </span>
          </div>

          <div className='page-content'>
                <div className="portal">
                  <div className='portal-body latest-blog'>
                    <div className='table-content'>
                      <div className="row">
                        {blog ? (
                          <>
                            {/* Left Side: Single Blog */}
                            <div className="col-lg-8">
                              <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                                <div className="align-items-start justify-content-start position-relative">
                                  <span className="badge bg-dark position-absolute top-0 start-0 m-2">
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = date.toLocaleString('default', { month: 'short' }).toUpperCase();
                                      return `${day} ${month}`;
                                    })()}
                                  </span>
                                  <div className="w-100 h-100 d-flex justify-content-center align-items-center text-white fs-4 fw-bold">
                                    <img
                                      src={`${config.imageBasePath}/blog/${blog.id}.${blog.image}`}
                                      alt={blog.name}
                                      className='img-fluid image-xs view-blog-img'
                                    />
                                  </div>
                                </div>

                                <div className="card-body">
                                  <p className="text-secondary small mb-1 mt-1">
                                    <i className="bi bi-list me-1"></i>{blog.blogCategory.name}
                                  </p>
                                  <h5 className="card-title fw-bold">
                                    <span className="text-dark text-decoration-none">
                                      {blog.name}
                                    </span>
                                  </h5>

                                  <p className="card-text text-muted">{blog.description}</p>
                                  <hr />
                                  <p className="text-secondary small mb-0">
                                    <i className="bi bi-calendar-event"></i>{" "}
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                      const year = date.getFullYear();
                                      return `${day}-${month}-${year}`;
                                    })()}
                                    <i className="bi bi-clock ms-2 me-1"></i>
                                    {(() => {
                                      const date = new Date(blog.createdDateTime);
                                      let hours = date.getHours();
                                      const minutes = String(date.getMinutes()).padStart(2, '0');
                                      const ampm = hours >= 12 ? 'PM' : 'AM';
                                      hours = hours % 12 || 12;
                                      return `${hours}:${minutes} ${ampm}`;
                                    })()}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* Right Side: Latest Blogs */}
                            <div className="col-lg-4 d-none d-lg-block">
                              <div className="card shadow-sm border-0 rounded-4 p-3">
                                <h6 className="fw-bold mb-3">
                                  <i className="bi bi-clock-history me-1"></i> Latest Blogs
                                </h6>
                                <ul className="list-group list-group-flush">
                                  {latestBlogs && latestBlogs.length > 0 ? (
                                    latestBlogs.slice(0, 5).map((item) => {
                                      const date = new Date(item.createdDateTime);
                                      const day = String(date.getDate()).padStart(2, '0');
                                      const month = String(date.getMonth() + 1).padStart(2, '0');
                                      const year = date.getFullYear();
                                      let hours = date.getHours();
                                      const minutes = String(date.getMinutes()).padStart(2, '0');
                                      const ampm = hours >= 12 ? 'PM' : 'AM';
                                      hours = hours % 12 || 12;
                                      return (
                                        <li key={item.id} className="list-group-item px-0 py-2">
                                          <Link to={`/blog/view/${item.id}`} className="text-decoration-none text-dark fw-semibold">
                                            <i className="bi bi-journal-text me-2"></i>{item.name}
                                          </Link>
                                          <br />
                                          <small className="text-muted">
                                            <i className="bi bi-calendar-event me-1"></i>{`${day}-${month}-${year}`}
                                            <i className="bi bi-clock ms-2 me-1"></i>{`${hours}:${minutes} ${ampm}`}
                                          </small>
                                        </li>
                                      );
                                    })
                                  ) : (
                                    <li className="list-group-item px-0">No latest blogs.</li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-12 text-center">
                            <p>No Blog found...!</p>
                          </div>
                        )}
                      </div>


                    </div>
                  </div>

                  <br />
               
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
